import(/* webpackMode: "eager" */ "/home/ubuntu/aidoo_aidooedu/app/page.js");
